import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import * as AuthActions from '../../modules/core/store/actions/auth.actions';
import * as fromApp from '../../modules/core/store/app.state';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@app/services/auth.service';
import { LoggingService, LogLevel } from '@app/services/logging.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HelperService } from '@app/services/helper.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrl: './forget-password.component.scss',
    standalone: false
})
export class ForgetPasswordComponent {
  static readonly COMPONENT_NAME = 'ForgetPasswordComponent';

  constructor(
    private store: Store<fromApp.AppState>,
    private snackbar: MatSnackBar,
    private authService: AuthService,
    private loggingService: LoggingService,
    private helper: HelperService
  ) {

  }

  formLoading: boolean = false;
  forgotPasswordForm = new FormGroup({
    username: new FormControl('', Validators.required),
  });

  validationMessages = {
    username: [
      { type: 'required', message: 'Email/Mobile/Username is required' },
    ],
  }

  onSubmit() {
    console.log('onSubmit: ', this.forgotPasswordForm.value);

    if (this.forgotPasswordForm.valid) {
      this.formLoading = true;

      let payload = this.forgotPasswordForm.value as Partial<{ username: string; }>;
      this.authService.forgotPassword(payload).pipe(
        finalize(() =>{
          this.formLoading = false;
        })
      ).subscribe({
        next: (response: any) => {
          this.loggingService.log(LogLevel.DEBUG, ForgetPasswordComponent.COMPONENT_NAME, 'forgotPassword: response:', response);
          this.helper.showSuccessMsg(response.message, 'Success');
        },
        error: (err: HttpErrorResponse) => {
          this.helper.showHttpErrorMsg(err);
        },
        complete: () => {
          this.formLoading = false;
        }
      });
    }

  }
}
